import React from 'react';

import LegalPage from 'components/LegalPage';
import content from './content.json';

export default function Terms() {
  return (
    <LegalPage
      content={content}
      seoTitle="Terms & Conditions · Lyfe"
      seoDescription="The terms of service governing your use of Lyfe Social's apps and services."
      path="/terms-and-conditions"
      fallbackTitle="Terms & Conditions"
    />
  );
}
